<div>
    <cdk-table-component
        [displayColumns]="displayColumns"
        [entities]="tableEntities"
        [dataSource]="dataSource"
        (rowClickAction)="navigatePlan($event)"
    ></cdk-table-component>
    @if (order.payment_plans.length === 0) {
        <raised-button (click)="setup()" color="primary" [styles]="{ width: '100%', 'margin': '15px 0' }" [disabled]="disableSetup">Setup Payments</raised-button>
    }
</div>
